// extracted by mini-css-extract-plugin
export default {"FeatureBlock":"FeatureBlock_FeatureBlock__uqnVc","row1":"FeatureBlock_row1__iFGIy","row2":"FeatureBlock_row2__3NHRO","row3":"FeatureBlock_row3__fCj0n"};